import { Navigate, useLocation } from "react-router-dom";

export default function EmailGuard({ children }) {
  const location = useLocation();
  const email = (sessionStorage.getItem("email") || "").trim();

  if (!email) {
    // redirect to signin, preserving where user wanted to go
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  return children;
}
